import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

// Which Boos the viewer may configure (Boo admin/owner), from the Boo list
// the app already caches. Used by hub-account surfaces to decide where a
// workspace account may be bound and whether a Boo-scoped connect is offered.
export function useBooConfigurable() {
  const query = useQuery({ queryKey: ["containers"], queryFn: api.containers.list });
  const rows = query.data?.data ?? [];
  const configurable = new Set(
    rows.filter((c) => c._permissions?.canConfigure === true).map((c) => c.id),
  );
  const names = new Map(rows.map((c) => [c.id, c.name] as const));
  return {
    query,
    configurable,
    names,
    canConfigure: (containerId: string) => configurable.has(containerId),
  };
}

// Whether the viewer may configure one Boo, from the same cached list.
// Undecided (undefined) while the list loads and while the Boo isn't in it
// yet — the list may have been cached before the Boo was created, so a
// missing row is not a denial. False only when the row is there and says no.
export function useBooCanConfigure(containerId: string | undefined): boolean | undefined {
  const { query, names, canConfigure } = useBooConfigurable();
  if (!containerId) return false;
  if (!query.isSuccess || !names.has(containerId)) return undefined;
  return canConfigure(containerId);
}
